module.exports = __webpack_public_path__ + "img/hat-cowboy-side.df414318.svg";